import { writable } from 'svelte/store'

export const sceneMode = writable<SceneMode>('default')
